export default "__VITE_ASSET__56fb110d__"